import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";
import {ProductSaleCostingReportModel} from "./product-sale-costing-report.model";
import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";

@Component({
    selector: "wbo-product-sale-costing-report",
    templateUrl: "./product-sale-costing-report.component.html",
    providers: [provideReportModel(ProductSaleCostingReportModel)]
})
export class ProductSaleCostingReportComponent extends AbstractReportPage {

    constructor(public model: ProductSaleCostingReportModel) {
        super();
    }
}
